import { type ReactElement } from 'react';

import DescriptionIcon from '@mui/icons-material/Description';
import LockIcon from '@mui/icons-material/Lock';
import { styled, Typography, type TypographyProps } from '@mui/material';

const StyledLinkTitle = styled(Typography)({
  color: 'white',
  fontSize: '8px',
  fontWeight: 700,
  textTransform: 'uppercase',
  display: 'flex',
  alignItems: 'center',
  gap: 2,
});

const StatusIconContainer = styled('span')({
  display: 'flex',
  fontSize: 7,
});

export type MainMenuLinkTitleProps = TypographyProps & {
  isDisabled: boolean;
  isSubscribed: boolean;
};

export const MainMenuLinkTitle = ({
  isDisabled,
  isSubscribed,
  ...restProps
}: MainMenuLinkTitleProps): ReactElement => {
  return (
    <StyledLinkTitle {...restProps}>
      {restProps.children}{' '}
      {isDisabled && (
        <StatusIconContainer>
          <LockIcon fontSize="inherit" />
        </StatusIconContainer>
      )}
      {!isSubscribed && !isDisabled && (
        <StatusIconContainer>
          <DescriptionIcon fontSize="inherit" />
        </StatusIconContainer>
      )}
    </StyledLinkTitle>
  );
};
